export default __webpack_public_path__ + "static/illustration-business.url-d5bb98fd80fe605336789bbbd6c7a088.svg";